import List from '@editorjs/list'

export default class CustomList extends List {
  renderSettings() {
    return super.renderSettings().filter(item => item.label != 'Checklist')
  }
}
